/**
 * Hook that validates if the string is a valid JSON and extracts the content of the 'body' field.
 * If it's not a valid JSON or doesn't have the 'body' field, returns the original string.
 * @param input - The string to validate and process
 * @returns The content of the 'body' field if valid, or the original string
 */
interface WhatsAppJSON {
  ContentSid: string;
  body: string;
}

export const useExtractBodyFromJson = (jsonString: string, variables?: Record<string, string>) => {
  try {
    if (!jsonString) return '';

    const parsedJson = JSON.parse(jsonString) as WhatsAppJSON;
    let content = parsedJson.body || '';

    if (variables) {
      Object.entries(variables).forEach(([key, value]) => {
        content = content.replace(`{{${key}}}`, value);
      });
    }

    return content;
  } catch {
    return jsonString;
  }
};

export const useConvertBodyVariables = (body: string, variables?: Record<string, string>) => {
  if (variables) {
    Object.entries(variables).forEach(([key, value]) => {
      body = body.replace(`{{${key}}}`, value);
    });
  }

  return body;
};

export const useExtractContentSidFromJson = (jsonString: string) => {
  try {
    const parsedJson = JSON.parse(jsonString) as WhatsAppJSON;
    return parsedJson.ContentSid || '';
  } catch {
    return '';
  }
};
